import { DataGrid, DataGridProps, GridColDef } from "@mui/x-data-grid"
import React, { useEffect } from "react"

interface ITableProps {
    columns: GridColDef<any>[],
    rows: any[]
}
const Table = (props: DataGridProps<any> & React.RefAttributes<HTMLDivElement> & {fixHeight?:number,apiRef?:any,subscribeEvents?:any} & {extraCalRow?:boolean}) => {
    const { fixHeight,apiRef,subscribeEvents } = props
    const getHeight = () => {
        let height
        const rowsLength = props.rows.length;
        if(rowsLength === 0) height = 120
        else height = rowsLength * 52 + 65

        if(props.hideFooter === false) height = height + 65

        return height
    }

      useEffect(() => {
        if (apiRef?.current?.subscribeEvent && subscribeEvents && subscribeEvents.length) {
            for(let eventToSubscribe of subscribeEvents){
                apiRef.current.subscribeEvent(eventToSubscribe.event,eventToSubscribe.handler);
            }
        }
      },[]);

    return <div style={{minHeight: fixHeight ? fixHeight + 'px' : getHeight() + 'px', width:'100%', position:'relative'}}>
        <div style={{position:'absolute', width:'100%', height:'100%'  }}>

        <DataGrid
            hideFooter
            sx={{
                ".MuiDataGrid-columnHeaders": { background: 'var(--primary_color_light)', borderRadius: '0' }, border: 'none', borderRadius: '0'
            }}
            {...props}
            apiRef={apiRef ? apiRef:null}
            />
            </div>
    </div>
}

export default Table